const FriendsSearchBar = ({ search, handleSearchBar }) => {
  return (
    <div className="flex flex-col sm:flex-row items-center mb-3">
      <div className="w-full my-4 flex max-w-sm">
        <svg
          className="w-5 inline-block relative left-6 bg-none text-darkRed"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
        <input
          className="bg-ivory px-7 py-0.5 w-10/12 text-darkRed shadow-sm shadow-darkRed rounded placeholder:text-darkRed focus:outline-none"
          placeholder="Recherche tes amis"
          type="text"
          value={search}
          onChange={handleSearchBar}
          name="name"
          required
        />
      </div>
      <button
        value=""
        className="friendsButtonStyle sm:ml-3 w-min gradient"
        onClick={handleSearchBar}
      >
        Effacer
      </button>
    </div>
  )
}

export default FriendsSearchBar
